/* =========================================================
   MAIN PRODUCT JAVASCRIPT (assets/main-product.js)
   ========================================================= */

(function () {
  try {
    var root = document.querySelector('.mp');
    if (!root) return;

    /* Base product price fallbacks */
    var basePrice = 0;
    var baseCompare = 0;

    var selectedCard = root.querySelector('[data-mp-variant-card].is-selected');
    if (selectedCard) {
      basePrice = parseInt(selectedCard.dataset.variantPrice, 10) || 0;
      baseCompare = selectedCard.dataset.variantComparePrice ? parseInt(selectedCard.dataset.variantComparePrice, 10) : 0;
    }

    /* ---------- Money Formatter Helper ---------- */
    function formatMoneyInRs(cents) {
      if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
        return Shopify.formatMoney(cents, 'Rs. {{amount}}').replace('INR', 'Rs.');
      }
      var rupees = (cents / 100).toFixed(2);
      var parts = rupees.split('.');
      var intPart = parts[0];
      var decPart = parts[1];

      var lastThree = intPart.substring(intPart.length - 3);
      var otherNumbers = intPart.substring(0, intPart.length - 3);
      if (otherNumbers !== '') {
        lastThree = ',' + lastThree;
      }
      var formattedInt = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;

      return 'Rs. ' + formattedInt + '.' + decPart;
    }

    function openCartDrawer() {
      if (window.MiniCart && typeof window.MiniCart.open === 'function') {
        window.MiniCart.open();
        return true;
      }
      var cd = document.querySelector('cart-drawer, mini-cart, side-cart, quick-cart-drawer');
      if (cd && typeof cd.open === 'function') {
        cd.open();
        return true;
      }
      if (window.cartDrawer && typeof window.cartDrawer.open === 'function') {
        window.cartDrawer.open();
        return true;
      }
      if (window.theme && window.theme.cart && typeof window.theme.cart.open === 'function') {
        window.theme.cart.open();
        return true;
      }
      return false;
    }

    function resetButtonStates() {
      if (buyNowBtn) {
        buyNowBtn.disabled = false;
        buyNowBtn.innerHTML = 'Buy it now';
      }
      if (addToCartBtn) {
        addToCartBtn.disabled = false;
        addToCartBtn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg> Add to Cart';
      }
    }

    window.addEventListener('pageshow', resetButtonStates);

    /* ---------- Image Slider Arrows & Scroll Controller ---------- */
    var slider = root.querySelector('[data-mp-slider]');
    var dots = root.querySelectorAll('[data-mp-dots] .mp__dot');
    var arrowPrev = root.querySelector('[data-mp-arrow-prev]');
    var arrowNext = root.querySelector('[data-mp-arrow-next]');

    if (slider) {
      function updateSliderState() {
        var slideWidth = slider.offsetWidth || 1;
        var scrollPos = slider.scrollLeft;
        var index = Math.round(scrollPos / slideWidth);
        var totalSlides = slider.querySelectorAll('.mp__gallery-slide').length;

        if (dots.length > 0) {
          dots.forEach(function (dot, idx) {
            if (idx === index) {
              dot.classList.add('is-active');
            } else {
              dot.classList.remove('is-active');
            }
          });
        }

        if (arrowPrev) {
          arrowPrev.style.display = index > 0 ? 'flex' : 'none';
        }
        if (arrowNext) {
          arrowNext.style.display = index < totalSlides - 1 ? 'flex' : 'none';
        }
      }

      slider.addEventListener('scroll', updateSliderState, { passive: true });

      if (arrowPrev) {
        arrowPrev.addEventListener('click', function () {
          var slideWidth = slider.offsetWidth;
          slider.scrollTo({ left: slider.scrollLeft - slideWidth, behavior: 'smooth' });
        });
      }

      if (arrowNext) {
        arrowNext.addEventListener('click', function () {
          var slideWidth = slider.offsetWidth;
          slider.scrollTo({ left: slider.scrollLeft + slideWidth, behavior: 'smooth' });
        });
      }

      if (dots.length > 0) {
        dots.forEach(function (dot) {
          dot.addEventListener('click', function () {
            var idx = parseInt(dot.dataset.index, 10) || 0;
            slider.scrollTo({ left: idx * slider.offsetWidth, behavior: 'smooth' });
          });
        });
      }

      updateSliderState();
    }

    /* ---------- Option 1 Swatches Interceptor (e.g. Color) ---------- */
    var opt1Btns = root.querySelectorAll('[data-mp-opt1-btn]');
    var opt1Label = root.querySelector('[data-mp-opt1-label]');

    if (opt1Btns.length > 0) {
      opt1Btns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var selectedVal = btn.dataset.value;

          opt1Btns.forEach(function (b) { b.classList.remove('is-selected'); });
          btn.classList.add('is-selected');

          if (opt1Label) opt1Label.textContent = selectedVal;

          var cards = root.querySelectorAll('[data-mp-variant-card]');
          var firstMatchingCard = null;

          cards.forEach(function (card) {
            if (card.dataset.option1 === selectedVal) {
              card.style.display = '';
              if (!firstMatchingCard) firstMatchingCard = card;
            } else {
              card.style.display = 'none';
            }
          });

          if (firstMatchingCard) {
            firstMatchingCard.click();
          }
        });
      });
    }

    /* ---------- Synchronized Live Animated 4-Stage Timeline Controller ---------- */
    var timelineEl = root.querySelector('[data-mp-timeline]');
    if (timelineEl) {
      var lineFill = timelineEl.querySelector('[data-mp-line-fill]');
      var node1 = timelineEl.querySelector('[data-node="1"]');
      var node2 = timelineEl.querySelector('[data-node="2"]');
      var node3 = timelineEl.querySelector('[data-node="3"]');

      function runTimelineLoop() {
        if (!lineFill) return;

        /* Step 0: Reset line to 0%, remove all ticks */
        lineFill.style.transition = 'none';
        lineFill.style.width = '0%';
        [node1, node2, node3].forEach(function (n) {
          if (n) n.classList.remove('is-active', 'is-zooming');
        });

        /* Stage 1: Line fills to 1st status (16.66%) -> Stop & Tick 1 */
        setTimeout(function () {
          lineFill.style.transition = 'width 0.6s cubic-bezier(0.4, 0, 0.2, 1)';
          lineFill.style.width = '16.66%';

          setTimeout(function () {
            if (node1) node1.classList.add('is-active', 'is-zooming');

            /* Stage 2: Line continues to 2nd status (50%) -> Stop & Tick 2 */
            setTimeout(function () {
              lineFill.style.transition = 'width 1.2s cubic-bezier(0.4, 0, 0.2, 1)';
              lineFill.style.width = '50%';

              setTimeout(function () {
                if (node2) node2.classList.add('is-active', 'is-zooming');

                /* Stage 3: Line continues to 3rd status (83.33%) -> Stop & Tick 3 */
                setTimeout(function () {
                  lineFill.style.transition = 'width 1.2s cubic-bezier(0.4, 0, 0.2, 1)';
                  lineFill.style.width = '83.33%';

                  setTimeout(function () {
                    if (node3) node3.classList.add('is-active', 'is-zooming');

                    /* Stage 4: Line continues past 3rd status to the end (100%) */
                    setTimeout(function () {
                      lineFill.style.transition = 'width 0.6s cubic-bezier(0.4, 0, 0.2, 1)';
                      lineFill.style.width = '100%';

                      /* Hold full completion, then restart loop */
                      setTimeout(function () {
                        runTimelineLoop();
                      }, 3500);

                    }, 400); // Pause briefly before final fill to right edge
                  }, 1200); // Wait for line to reach Node 3
                }, 400); // Pause briefly before filling to Node 3
              }, 1200); // Wait for line to reach Node 2
            }, 400); // Pause briefly before filling to Node 2
          }, 600); // Wait for line to reach Node 1
        }, 300);
      }

      runTimelineLoop();
    }

    /* Fixed unit price - does NOT multiply by quantity */
    function updatePricesFromCard(card) {
      var rawPrice = basePrice;
      var rawCompare = baseCompare;

      if (!card) card = root.querySelector('[data-mp-variant-card].is-selected');

      if (card && card.dataset.variantPrice) {
        rawPrice = parseInt(card.dataset.variantPrice, 10);
        rawCompare = card.dataset.variantComparePrice ? parseInt(card.dataset.variantComparePrice, 10) : 0;
      }

      if (variantPriceEl) {
        variantPriceEl.textContent = formatMoneyInRs(rawPrice);
      }

      if (variantCompareEl) {
        if (rawCompare > rawPrice) {
          variantCompareEl.textContent = formatMoneyInRs(rawCompare);
          variantCompareEl.style.display = '';
        } else {
          variantCompareEl.style.display = 'none';
        }
      }
    }

    /* ---------- Dynamic Prices & Buttons ---------- */
    var variantIdInput = root.querySelector('[data-mp-variant-id]');
    var variantPriceEl = root.querySelector('[data-mp-variant-price]');
    var variantCompareEl = root.querySelector('[data-mp-variant-compare]');
    var buyNowBtn = root.querySelector('[data-mp-buy-now]');
    var addToCartBtn = root.querySelector('[data-mp-add-to-cart]');
    var qtyInput = root.querySelector('[data-mp-qty-input]');
    var qtyMinus = root.querySelector('[data-mp-qty-minus]');
    var qtyPlus = root.querySelector('[data-mp-qty-plus]');

    if (qtyInput) {
      if (qtyMinus) {
        qtyMinus.addEventListener('click', function () {
          var current = parseInt(qtyInput.value, 10) || 1;
          if (current > 1) {
            qtyInput.value = current - 1;
            updatePricesFromCard();
          }
        });
      }
      if (qtyPlus) {
        qtyPlus.addEventListener('click', function () {
          var current = parseInt(qtyInput.value, 10) || 1;
          qtyInput.value = current + 1;
          updatePricesFromCard();
        });
      }
      qtyInput.addEventListener('change', function () {
        var val = parseInt(qtyInput.value, 10);
        if (isNaN(val) || val < 1) {
          qtyInput.value = 1;
        }
        updatePricesFromCard();
      });
    }

    if (addToCartBtn) {
      addToCartBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (addToCartBtn.disabled) return;

        var variantId = variantIdInput ? variantIdInput.value : '';
        var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;

        addToCartBtn.disabled = true;
        addToCartBtn.innerHTML = 'Adding…';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('add failed');
            return res.json();
          })
          .then(function () {
            addToCartBtn.innerHTML = 'Added!';
            resetButtonStates();
            openCartDrawer();
          })
          .catch(function () {
            resetButtonStates();
            openCartDrawer();
          });
      });
    }

    /* DIRECT INSTANT BUY NOW -> CHECKOUT REDIRECT */
    if (buyNowBtn) {
      buyNowBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (buyNowBtn.disabled) return;

        var variantId = variantIdInput ? variantIdInput.value : '';
        var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;

        buyNowBtn.disabled = true;
        buyNowBtn.innerHTML = 'Redirecting…';

        window.location.href = '/cart/' + variantId + ':' + qty + '?checkout';
      });
    }

    root.querySelectorAll('[data-mp-variant-card]').forEach(function (card) {
      card.addEventListener('click', function () {
        if (card.disabled) return;

        root.querySelectorAll('[data-mp-variant-card]').forEach(function (c) { c.classList.remove('is-selected'); });
        card.classList.add('is-selected');

        var id = card.dataset.variantId;
        var image = card.dataset.variantImage;

        if (variantIdInput) variantIdInput.value = id;

        updatePricesFromCard(card);

        if (slider && image) {
          var slides = root.querySelectorAll('.mp__gallery-slide');
          slides.forEach(function (slide, idx) {
            var img = slide.querySelector('img');
            if (img && img.src && img.src.indexOf(image) !== -1) {
              slider.scrollTo({ left: idx * slider.offsetWidth, behavior: 'smooth' });
            }
          });
        }

        var isAvailable = !card.classList.contains('is-unavailable');
        if (buyNowBtn) buyNowBtn.disabled = !isAvailable;
        if (addToCartBtn) addToCartBtn.disabled = !isAvailable;
      });
    });

    /* ---------- Bundle ---------- */
    var bundleRoot = root.querySelector('[data-bundle-offer]');
    if (bundleRoot) {
      var checkboxes = Array.prototype.slice.call(bundleRoot.querySelectorAll('[data-bundle-checkbox]'));
      var requiredCount = parseInt(bundleRoot.dataset.requiredCount, 10) || checkboxes.length;
      var discountPercent = parseFloat(bundleRoot.dataset.discountPercent) || 0;

      var countLabelEl = bundleRoot.querySelector('[data-bundle-count-label]');
      var comparePriceEl = bundleRoot.querySelector('[data-bundle-compare-price]');
      var totalPriceEl = bundleRoot.querySelector('[data-bundle-total-price]');
      var ctaLabelEl = bundleRoot.querySelector('[data-bundle-cta-label]');
      var ctaButtonEl = bundleRoot.querySelector('[data-bundle-add-to-cart]');
      var bannerEl = bundleRoot.querySelector('[data-bundle-banner]');
      var bannerTextEl = bundleRoot.querySelector('[data-bundle-banner-text]');
      var savePillEl = bundleRoot.querySelector('[data-bundle-save-pill]');
      var saveTextEl = bundleRoot.querySelector('[data-bundle-save-text]');

      function getChecked() {
        return checkboxes.filter(function (cb) { return cb.checked; });
      }

      function recalcBundle() {
        var checked = getChecked();
        var fullTotal = 0;

        checkboxes.forEach(function (cb) {
          var itemLabel = cb.closest('[data-bundle-item]');
          if (cb.checked) {
            itemLabel.classList.remove('is-unselected');
            fullTotal += parseInt(itemLabel.dataset.price, 10) || 0;
          } else {
            itemLabel.classList.add('is-unselected');
          }
        });

        var qualifies = checked.length >= requiredCount;
        var discountedTotal = qualifies ? Math.round(fullTotal * (100 - discountPercent) / 100) : fullTotal;
        var savings = fullTotal - discountedTotal;

        if (countLabelEl) countLabelEl.textContent = 'Total (' + checked.length + ' item' + (checked.length === 1 ? '' : 's') + ')';

        if (qualifies) {
          if (comparePriceEl) { comparePriceEl.style.display = ''; comparePriceEl.textContent = formatMoneyInRs(fullTotal); }
          if (totalPriceEl) totalPriceEl.textContent = formatMoneyInRs(discountedTotal);
          if (bannerEl) bannerEl.style.display = 'none';

          if (savePillEl && saveTextEl) {
            saveTextEl.textContent = 'You save ' + formatMoneyInRs(savings);
            savePillEl.style.display = '';
          }
        } else {
          if (comparePriceEl) comparePriceEl.style.display = 'none';
          if (totalPriceEl) totalPriceEl.textContent = formatMoneyInRs(fullTotal);
          if (savePillEl) savePillEl.style.display = 'none';

          var remaining = requiredCount - checked.length;
          if (remaining > 0 && bannerEl && bannerTextEl) {
            bannerTextEl.textContent = 'Add ' + remaining + ' more item' + (remaining === 1 ? '' : 's') + ' to get ' + discountPercent + '% OFF on your order!';
            bannerEl.style.display = '';
          } else if (bannerEl) {
            bannerEl.style.display = 'none';
          }
        }

        if (ctaLabelEl) ctaLabelEl.textContent = 'Add ' + checked.length + ' to Cart';
        if (ctaButtonEl) ctaButtonEl.disabled = checked.length === 0;
      }

      checkboxes.forEach(function (cb) { cb.addEventListener('change', recalcBundle); });

      if (ctaButtonEl) {
        ctaButtonEl.addEventListener('click', function () {
          var checked = getChecked();
          if (!checked.length) return;

          var items = checked.map(function (cb) { return { id: cb.value, quantity: 1 }; });

          ctaButtonEl.disabled = true;
          var originalLabel = ctaLabelEl ? ctaLabelEl.textContent : '';
          if (ctaLabelEl) ctaLabelEl.textContent = 'Adding…';

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: items })
          })
            .then(function (res) { if (!res.ok) throw new Error('add failed'); return res.json(); })
            .then(function () {
              if (ctaLabelEl) ctaLabelEl.textContent = 'Added!';
              setTimeout(function () { if (ctaLabelEl) ctaLabelEl.textContent = originalLabel; ctaButtonEl.disabled = false; }, 1500);
              openCartDrawer();
            })
            .catch(function () {
              if (ctaLabelEl) ctaLabelEl.textContent = originalLabel;
              ctaButtonEl.disabled = false;
              openCartDrawer();
            });
        });
      }

      recalcBundle();
    }
  } catch (err) {
    console.error('Section MP script error:', err);
  }
})();